import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psa-licence',
  templateUrl: './psa-licence.component.html',
  styleUrls: ['./psa-licence.component.css']
})
export class PsaLicenceComponent implements OnInit {
  title="Licence Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/psadetails/psa-list/psa-licence/psa-licence.component.ts